// 定义常量
export const MAX_FILE_SIZE_MB = 20; //最大上传20MB
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024; // 20MB 转换为字节

//手机号正则校验
export const phoneRegexp =
  "/^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])d{8}$/";

//邮箱正则校验
export const emailRegexp = "[w]+@[A-Za-z]+(.[A-Za-z0-9]+){1,2}";

export const FORMATS_DATE = {
  DATE: "YYYY-MM-DD",
  DATETIME: "YYYY-MM-DD HH:mm:ss",
};

//角色类型， assistant表示AI，cs表示人工客服，user表示用户
export const roleType = {
  assistant: "assistant",
  cs: "cs",
  user: "user",
};

export const isHTML = (str: string) => /<[a-z][\s\S]*>/i.test(str);

//站点枚举
export enum SiteEnum {
  TS = "ts",
  PF = "pf",
  NXZ = "nxz",
  NXZSOFTWARE = "nxzsoftware",
  ULTFONE = "ultfone",
  "4DDIG" = "4ddig",
  HITPAW = "hitpaw",
  EDIMAKOR = "edimakor",
  BLIPCUT = "blipcut",
}

// 域名与主题的映射关系（常量）
export const DOMAIN_THEME_MAP: any = {
  tenorshare: SiteEnum.TS,
  passfab: SiteEnum.PF,
  niuxuezhang: SiteEnum.NXZ,
  nxzsoftware: SiteEnum.NXZSOFTWARE,
  ultfone: SiteEnum.ULTFONE,
  "4ddig": SiteEnum["4DDIG"],
  hitpaw: SiteEnum.HITPAW,
  edimakor: SiteEnum.EDIMAKOR,
  blipcut: SiteEnum.BLIPCUT,
};

//根据域名获取对应站点客服图标
export const siteServiceLogo: any = {
  [SiteEnum.TS]: {
    logo: "/images/ts.png",
    aiAvatar: "/avatar/ts.png",
  },
  [SiteEnum.PF]: {
    logo: "/images/common.png",
    aiAvatar: "/avatar/passfab.png",
  },
  [SiteEnum.NXZ]: {
    logo: "/images/common.png",
    aiAvatar: "/avatar/hitpaw.png",
  },
  [SiteEnum.NXZSOFTWARE]: {
    logo: "/images/common.png",
    aiAvatar: "/avatar/ts.png",
  },
  [SiteEnum.BLIPCUT]: {
    logo: "/images/common.png",
    aiAvatar: "/avatar/blipcut.png",
  },
  [SiteEnum.HITPAW]: {
    logo: "/images/hitpaw.png",
    aiAvatar: "/avatar/hitpaw.png",
    hoverLogo: "/images/hitpaw-hover.png",
  },
  [SiteEnum.EDIMAKOR]: {
    logo: "/images/edimakor.png",
    aiAvatar: "/avatar/edimakor.png",
  },
  [SiteEnum.ULTFONE]: {
    logo: "/images/common.png",
    aiAvatar: "/avatar/ult.png",
  },
  [SiteEnum["4DDIG"]]: {
    logo: "/images/common.png",
    aiAvatar: "/avatar/ult.png",
  },
};

//中文站点
export const siteCNList = [
  "tenorshare.cn",
  "passfab.cn",
  "niuxuezhang.cn",
  "nxzsoftware.cn",
];

//对应ws连接状态
export const wsStatus = {
  CONNECTING: 0,
  OPEN: 1,
  CLOSING: 2,
  CLOSED: 3,
};

// 消息确认模式枚举
export const AckMode = {
  ACK_NOT_REQUIRED: 0, // 无需确认
  ACK_REQUIRED: 1, // 需要确认
  ACK_CONFIRMED: 2, // 已确认收到
  ACK_NOT_SENT: 3, // 消息发送失败
} as const;

//取消订阅类型
export const cancelSubscriptionType = {
  supportContact: 1,
  stillCancel: 0,
  useDiscount: 1,
};

/**
 * 组件类型枚举
 */
export enum ComponentsTypeEnum {
  TICKET = "ticket", //表单
  GRADE = "grade", //评分
  EMAIL = "email", //邮箱
  CODE = "code", //验证码
  CANCEL_SUBSCRIPTION_BTN_OPTION = "cancel_subscription_btn_option", //取消订阅按钮
  CANCEL_SUBSCRIPTION_PRODUCT_LIST = "cancel_subscription_product_list", //取消订阅产品列表
  CANCEL_SUBSCRIPTION_PAUSE = "cancel_subscription_pause", //取消订阅暂停
  CANCEL_SUBSCRIPTION_DISCOUNT = "cancel_subscription_discount", //取消订阅折扣
  FAQ = "faq", //常见问题快捷标签
}

//用户点赞类型
export enum LikeTypeEnmu {
  USEFUL = 1, //有用
  UNUSEFUL = 0, //没用
}

export enum YesOrNoEnmu {
  NO = 0,
  YES = 1,
  EMPTY = 404,
}
